import { gql } from '@apollo/client';

export const GET_FRAMEWORK = gql`
  query GetFramework($id: ID!) {
    framework: getFramework(id: $id) {
      id
      name
      indicatorsOnly
      levels {
        id
        name
        level
        allowIndicators
      }
      defaults {
        id
        type
        number
        description
        level {
          id
        }
        parentResult {
          id
        }
      }
    }
  }
`;
